export { AnimatedSegmentedControl } from './AnimatedSegmentedControl'
export type {
  AnimatedSegmentedControlProps,
  AnimatedSegmentOption,
} from './AnimatedSegmentedControl'
export type { AnimatedSegmentedControlVariant } from './AnimatedSegmentedControl.styles'
